import React from 'react'
import styled from 'styled-components'

import { TableCell } from '../TableCell'

const TableFooterElement = styled.th`
  padding: 0;
  height: 0; // fake height to make cell height work
  text-align: left;
`

export const TableFooter = ({
    type,
    colSpan,
    width,
    getRowProps = () => {},
    getColumnProps = () => {},
    getFooterProps = () => {},
    getCellProps = () => {},
    children,
}) => {
    const columnProps = getColumnProps()

    return (
        <TableFooterElement
            className="table-header"
            width={width}
            colSpan={colSpan}
            {...columnProps.footerProps}
        >
            <TableCell
                type={type}
                gap="5px"
                align="center"
                variant="body2"
                {...getRowProps()}
                {...columnProps}
                {...columnProps.footerProps}
                {...getFooterProps()}
                {...getCellProps()}
            >
                {children}
            </TableCell>
        </TableFooterElement>
    )
}